import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles/AnnouncementEdit.css';

export function UpdateAnnouncementForm() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        trainingDate: '',
        trainingTime: '',
        venue: '',
    });
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            announcementData: {
                trainingDate: formData.trainingDate,
                trainingTime: formData.trainingTime,
                venue: formData.venue,
            },
        };

        try {
            const response = await fetch(
                "https://api.jsonbin.io/v3/b/677d3e0bacd3cb34a8c58606",
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Master-Key": "$2a$10$g9HFN7jTfYswexcES.bBuOx0cARlZHwZ6eQHA6.JDZTbkAwi9CWXa",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (response.ok) {
                setMessage(t('announcements.edit.successMessage'));
                setError(null);
            } else {
                const errorText = await response.text();
                console.error("Update failed:", errorText);
                setError(`${t('announcements.edit.errorFailed')} ${response.status}`);
                setMessage(null);
            }
        } catch (err) {
            console.error("Error during API call:", err);
            setError(t('announcements.edit.errorOccurred'));
            setMessage(null);
        }
    };

    return (
        <div className="update-form-container">
            <h2>{t('announcements.edit.title')}</h2>
            {message && <p className="success-message">{message}</p>}
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleSubmit} className="update-form">
                <div className="form-group">
                    <label htmlFor="trainingDate">{t('announcements.edit.trainingDateLabel')}</label>
                    <input
                        type="text"
                        id="trainingDate"
                        name="trainingDate"
                        value={formData.trainingDate}
                        onChange={handleChange}
                        placeholder={t('announcements.edit.trainingDatePlaceholder')}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="trainingTime">{t('announcements.edit.trainingTimeLabel')}</label>
                    <input
                        type="text"
                        id="trainingTime"
                        name="trainingTime"
                        value={formData.trainingTime}
                        onChange={handleChange}
                        placeholder={t('announcements.edit.trainingTimePlaceholder')}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="venue">{t('announcements.edit.venueLabel')}</label>
                    <input
                        type="text"
                        id="venue"
                        name="venue"
                        value={formData.venue}
                        onChange={handleChange}
                        placeholder={t('announcements.edit.venuePlaceholder')}
                        required
                    />
                </div>
                <button type="submit" className="submit-btn">
                    {t('announcements.edit.submitBtn')}
                </button>
            </form>
        </div>
    );
}